// 导入基本公共资源
import http from './../../../base/api/public'
let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
    // 获取占桩费率列表
    getBillingRules(params) {
        return http.requestPost(apiPre + service.res + '/res/re/takeUpPileBillingRules/getBillingRules', params)
    },
    // 删除占桩费率列表数据
    delete(params) {
        return http.requestPost(apiPre + service.res + '/res/re/takeUpPileBillingRules/delete', params)
    },
    // 获取占桩费率列表
    save(params) {
        return http.requestPost(apiPre + service.res + '/res/re/takeUpPileBillingRules/save', params)
    },
    // 编辑回显占桩费率列表
    findByRulesId(operatorId, rulesId) {
        return http.requestGet(apiPre + service.res + `/res/re/takeUpPileBillingRules/findByRulesId?operatorId=${operatorId}&rulesId=${rulesId}`)
    },
    // 修改占桩费率列表
    update(params) {
        return http.requestPost(apiPre + service.res + '/res/re/takeUpPileBillingRules/update', params)
    },
    // 占桩费率记录分页查询
    getBillingRulesRecord(params) {
        return http.requestPost(apiPre + service.res + '/res/re/takeUpPileBillingRulesRecord/getBillingRulesRecord', params)
    },
    // 占桩费率记录详情
    findByRecordId(recordId) {
        return http.requestGet(apiPre + service.res + `/res/re/takeUpPileBillingRulesRecord/findByRecordId?recordId=${recordId}`)
    },
    // 占桩费操作枚举
    recordOperationTypeEnum() {
        return http.requestGet(apiPre + service.res + `/res/re/takeUpPileBillingRulesRecord/recordOperationTypeEnum`)
    },
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/OccupancyFeeApi.js